import { useQuery } from "@tanstack/react-query";

import { getBettingSelectionWithTranslations } from "@/api/bettingSelections";
import { BettingSelectionsQueryKeys } from "./bettingSelectionsQueryKeys";

export const useBettingSelectionWithTranslations = (id: number | null) => {
  return useQuery({
    queryKey: [BettingSelectionsQueryKeys.BettingSelectionWithTranslations, id],
    queryFn: () => getBettingSelectionWithTranslations(id!),
    enabled: id !== null,
  });
};
